import styled from 'styled-components';
import {
  whiteColor,
  maxAppWidth,
  primaryColor,
  mediumFont,
  screenSize,
} from '@app/styles';
import DefaultProfileImg from '@app/assets/images/user_profile.svg';

type TabProps = {
  selected?: boolean;
};
type ProfileProps = {
  image?: string;
};
export const BackgroundContainer = styled.div`
  background: ${whiteColor};
  border-bottom: 1px solid #dce0e8;
  top: 65px;
  position: fixed;
  left: 0;
  width: 100%;
  z-index: 1;
  @media (${screenSize.tablet}) {
    top: 55px;
  }
`;
export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  position: relative;
  max-width: ${maxAppWidth};
  margin: 0 auto;
`;
export const InnerContainer = styled.div`
  display: flex;
  align-items: center;
  height: 48px;
`;
export const Tab = styled.div`
  display: none;
  height: 48px;
  align-items: center;
  padding: 0 5px;
  margin: 0 10px;
  color: #767b8a;
  cursor: pointer;
  svg {
    margin-right: 5px;
  }
  ${({ selected }: TabProps) => {
    if (selected) {
      return `border-bottom:3px solid #40ddc6;
                    color:#3a435e;`;
    } else {
      return `border-bottom:3px solid #fff;`;
    }
  }};
  @media (${screenSize.tablet}) {
    display: flex;
  }
`;
export const InviteLink = styled.span`
  display: none;
  color: ${primaryColor};
  font-size: 16px;
  ${mediumFont};
  cursor: pointer;
  @media (${screenSize.tablet}) {
    display: block;
  }
`;
export const ProfileTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 100%;
  height: 48px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 0 25px 0 15px;
  color: #3a435e;
  cursor: pointer;
  svg {
    position: absolute;
    right: 15px;
    top: 12px;
  }
  @media (${screenSize.tablet}) {
    border-left: 1px solid #dce0e8;
    border-right: 1px solid #dce0e8;
    width: auto;
    min-width: 178px;
    position: relative;
    svg {
      right: 5px;
    }
  }
`;
export const Profileicon = styled.div`
  width: 36px;
  height: 36px;
  margin-right: 10px;
  border-radius: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  ${({ image }: ProfileProps) => {
    if (image) {
      return `background-image:url(${image});`;
    } else {
      return `background-image:url(${DefaultProfileImg});`;
    }
  }}
`;
export const MobileDropDown = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  height: auto;
  background: ${whiteColor};
  box-shadow: 0 11px 24px 0px rgba(0, 0, 0, 0.4);
  z-index: 2;
  @media (${screenSize.tablet}) {
    display: none;
  }
`;
export const Option = styled.div`
  display: flex;
  align-items: center;
  height: 45px;
  padding: 0 20px;
  border-top: 1px solid #dce0e8;
`;
